@import "~@govbr-ds/core/src/components/upload/upload";

:host {
  display: block;
}

.br-upload {
  br-icon {
    margin-right: var(--spacing-scale-base);
  }
}
